import {
  MdOutlineStorefront,
  MdOutlineCloudUpload,
  MdCloudQueue,
  MdDeviceHub,
  MdFeaturedPlayList,
  MdNewReleases,
  MdOutlineWebhook,
  MdOutlineRocketLaunch,
  MdHistory,
} from 'react-icons/md';
import { ROUTE_STRING } from 'constants/RouteString';
import { AuthorizePermission } from '@tenant/utility/constants/authorizePermission';

const routesConfig = [
  {
    id: 'announcement',
    title: "Announcement",
    messageId: 'Announcement',
    type: 'group',
    children: [
      {
        id: 'WhatsNewSection',
        title: "What's New",
        messageId: 'WhatsNewSection',
        icon: <MdNewReleases />,
        type: 'whatsNew', // Special type to identify this as a What's New trigger
        permissionIds: [], // No specific permissions needed for viewing what's new
      },
    ],
  },

  {
    id: 'app',
    title: 'Developer',
    messageId: 'Developer',
    type: 'group',
    children: [
      {
        id: 'Apps',
        title: 'Apps',
        messageId: 'Apps',
        icon: <MdOutlineStorefront />,
        type: 'item',
        url: ROUTE_STRING.LIST_APP.LIST,
        permissionIds: [AuthorizePermission.APP_READ],
      },
      {
        id: 'CreateApp',
        title: 'Create App',
        messageId: 'CreateApp',
        icon: <MdOutlineCloudUpload />,
        type: 'item',
        url: ROUTE_STRING.CREATE_APP,
        permissionIds: [AuthorizePermission.APP_CREATE],
      },
      {
        id: 'AuditLog',
        title: 'Audit Log',
        messageId: 'AuditLog',
        icon: <MdHistory />,
        type: 'item',
        url: ROUTE_STRING.AUDIT_LOG.LIST,
        permissionIds: [AuthorizePermission.AUDIT_READ],
      },
    ],
  },

  {
    id: 'Deployment',
    title: 'Deployment',
    messageId: 'Deployment',
    type: 'group',
    children: [
      {
        id: 'Pipelines',
        title: 'Pipelines',
        messageId: 'Pipelines',
        icon: <MdOutlineRocketLaunch />,
        type: 'item',
        url: ROUTE_STRING.PIPELINE.LIST,
        permissionIds: [AuthorizePermission.PIPELINE_READ],
      },
      {
        id: 'DockerRepositories',
        title: 'Docker Image',
        messageId: 'DockerRepositories',
        icon: <MdCloudQueue />,
        type: 'item',
        url: ROUTE_STRING.DOCKER_IMAGE.LIST,
        permissionIds: [AuthorizePermission.REPOSITORY_READ],
      },
      {
        id: 'AppInstance',
        title: 'App Instance',
        messageId: 'AppInstance',
        icon: <MdDeviceHub />,
        type: 'item',
        url: ROUTE_STRING.APP_INSTANCE.LIST,
        permissionIds: [AuthorizePermission.APP_INSTANCE_CONTAINER_READ],
      },
      {
        id: 'IDPClients',
        title: 'Joblogic IDP Clients',
        messageId: 'IDPClients',
        icon: <MdFeaturedPlayList />,
        type: 'item',
        url: ROUTE_STRING.IDP_CLIENT.LIST,
        permissionIds: [AuthorizePermission.APP_INSTANCE_CONTAINER_READ],
      },
      {
        id: 'WebhookRegistrations',
        title: 'Webhook Registrations',
        messageId: 'WebhookRegistrations',
        icon: <MdOutlineWebhook />,
        type: 'item',
        url: ROUTE_STRING.WEBHOOK_REGISTRATION.LIST,
        permissionIds: [AuthorizePermission.WEBHOOK_REGISTRATION_READ],
      },
    ],
  },
];

export default routesConfig;
